
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Home from './Pages/Home.js';
import SearchPages from './Pages/SearchPages.js';
import Header from './components/Header.js';
import Footer from './components/Footer.js';

function App() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchPages />} />
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "",
    minHeight: "100vh",
  },
}));

export default App;
